<template>
  <div class="dashboard">
    <section class="section overall-data">
      <h2>总数据</h2>
      <div class="card-row" >
        <div
          v-for="(item, index) in overallData"
          :key="'overall' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value" >{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>
    <section class="section region-data">
      <h2>浙江数据</h2>
      <div class="card-row">
        <div
          v-for="(item, index) in zhejiangData"
          :key="'zj' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value">{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>
    <section class="section region-data">
      <h2>福建数据</h2>
      <div class="card-row">
        <div
          v-for="(item, index) in fujianData"
          :key="'fj' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value">{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>

    <section class="section customer-data">
      <h2>部分客户数据</h2>
      <el-table :data="zjCustomerData" stripe style="width: 100%">
        <el-table-column prop="uname" label="用户名"  style="width: 30%"></el-table-column>
        <el-table-column prop="todayConsume" label="今日消费" style="width: 30%" sortable></el-table-column>
        <el-table-column prop="yesConsume" label="昨日消费" style="width: 30%" sortable></el-table-column>
        <el-table-column prop="diff" label="消耗差"></el-table-column>
      </el-table>
    </section>

  </div>
</template>

<script>
import axios from "axios";
const Big = require('big.js');

export default {
  name: "Dashboard",
  data() {
    return {
      // 第一部分：总数据（默认数据，可后续替换 API 获取的数据）
      overallData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: 0 }
      ],
      // 第二部分：浙江数据
      zhejiangData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: 0 }
      ],
      // 第三部分：福建数据
      fujianData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: 0 }
      ],
      // 模拟从接口获取的浙江客户参数（第四部分需要使用的参数）
      zjusers: [
        { uname: "点众短剧", uaccounts: ["dianzh"] },
        { uname: "挖财", uaccounts: ["ZJwacai"] },
        { uname: "众安", uaccounts: ["zjzabx"] },
        { uname: "叶福顺", uaccounts: ["yefushun1"] },

        { uname: "踏歌行", uaccounts: ["HZyangsheng"] },
        { uname: "木易", uaccounts: ["FJyangsheng"] },
        { uname: "千堆雪", uaccounts: ["qianduxue"] },
        { uname: "追书", uaccounts: ["zjzhuishu"] },
        { uname: "生米", uaccounts: ["shengmi"] },
        { uname: "爱测评", uaccounts: ["tjfeimao"] }
      ],
      // 模拟福建客户参数（第五部分）
      fjusers: [
        { uname: "千堆雪", uaccounts: ["qianduxue3"] },
        { uname: "追书", uaccounts: ["fjzhuishu"] },
        { uname: "生米", uaccounts: ["shengmi2"] },
        { uname: "爱测评", uaccounts: ["tjfeimao1"] },
        { uname: "叶福顺", uaccounts: ["yefushun2"] }
      ],
      // 用于表格展示的客户数据，实际数据应通过接口获取，这里先用随机数据
      zjCustomerData: [],
      fjCustomerData: [],
      todayAll: [], // 今日数据
      yesAll: [],   // 昨日数据
      result: [],   // zj处理后的结果
      fjresult: [],   // fj处理后的结果

      zjcookie:'',
      fjcookie:''

    };
  },
  created() {
    this.fetchHdCookieData();

  },
  methods: {
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        this.fjcookie = response.data.data.records[1].hdcookie
        // this.$message.warning('数据查询中，请耐心等候...', 000);
        await    this.fetchCustomerData();
        // await       this.getFJData();
        // await       this.getZJData();




        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    // 模拟接口请求，生成随机的客户消耗数据
// 修改后的 fetchCustomerData 方法
    async fetchCustomerData() {
      axios.get("https://control.zjwec.cn/api/vivo/getDataFromRedis").then((response) => {
        console.log(response);
        this.overallData[0].value = response.data.todayTotal;
        this.overallData[1].value = response.data.yesterdayTotal;
        this.overallData[2].value = response.data.consumeDifference
        this.overallData[3].value = response.data.ratio

        this.fujianData[0].value= response.data.fujianData[0].fjToDayAll
        this.fujianData[1].value= response.data.fujianData[1].fjYesDayAll
        this.fujianData[2].value= response.data.fujianData[2].fjcj
        this.fujianData[3].value= response.data.fujianData[3].fjhb

        this.zhejiangData[0].value= response.data.zhejiangData[0].fjToDayAll
        this.zhejiangData[1].value= response.data.zhejiangData[1].fjYesDayAll
        this.zhejiangData[2].value= response.data.zhejiangData[2].fjcj
        this.zhejiangData[3].value= response.data.zhejiangData[3].fjhb

        this.zjCustomerData  = response.data.zjresult
        this.$message.success("查询成功")

      })


      // try {
      //   const [zjToday, fjToday, zjYes, fjYes] = await Promise.all([
      //     axios.get("https://control.zjwec.cn/api/vivo/querySecConsumeTotal", { params: { cookie: this.zjcookie } }),
      //     axios.get("https://control.zjwec.cn/api/vivo/querySecConsumeTotal", { params: { cookie: this.fjcookie } }),
      //     axios.get("https://control.zjwec.cn/api/vivo/queryYesterdayConsumeTotal", { params: { cookie: this.zjcookie } }),
      //     axios.get("https://control.zjwec.cn/api/vivo/queryYesterdayConsumeTotal", { params: { cookie: this.fjcookie } })
      //   ]);
      //
      //   // 安全获取数值并设置默认值
      //   const safeNumber = (res, path) => {
      //     try {
      //       return Number(res.data.data[path]) || 0;// 修改后（兼容 ES6）
      //     } catch (e) {
      //       return 0;
      //     }
      //   };
      //
      //   const todayAll = new Big(safeNumber(zjToday, 'todayConsumeAmount'))
      //     .plus(safeNumber(fjToday, 'todayConsumeAmount'))
      //     .round(0, 0)
      //     .toNumber();
      //
      //   const yesAll = new Big(safeNumber(zjYes, 'yesterdayConsumeTotal'))
      //     .plus(safeNumber(fjYes, 'yesterdayConsumeTotal'))
      //     .round(0, 0)
      //     .toNumber();
      //
      //   // 更新总数据（添加除零保护）
      //   this.overallData[0].value = todayAll;
      //   this.overallData[1].value = yesAll;
      //   this.overallData[2].value = todayAll - yesAll;
      //   this.overallData[3].value = yesAll !== 0
      //     ? new Big(todayAll - yesAll).times(100).div(yesAll).toFixed(2)
      //     : 'N/A';
      //
      // } catch (error) {
      //   console.error("总数据请求失败", error);
      //   this.$message.error('总数据获取失败');
      // }
    },
    async  getZJData() {
      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };
      // 使用 this.zjcookie 进行请求
      const cookie = this.zjcookie;
      Promise.all([
        fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie),
        fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie)
      ])
        .then(([todayAll, yesAll]) => {
          this.todayAll = todayAll;
          this.yesAll = yesAll;

          this.result = this.zjusers.map(user => {
            const todayConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.todayAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            const yesConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.yesAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(
                accountData.totalConsume) : 0);
            }, 0);

            return {
              uname: user.uname,
              todayConsume: Number(todayConsume.toFixed(2)),
              yesConsume: Number(yesConsume.toFixed(2))
            };
          });
          // 遍历 this.result 数组，计算 diff 和 chain，同时更新 todayConsume、yesConsume、diff
          this.result.forEach(user => {
            // 查找匹配的对象
            const matchingObj = this.fjresult.find(fjObj => fjObj.uname === user.uname);

            // 如果找到了对应的对象，则更新属性值
            if (matchingObj) {
              user.todayConsume = (user.todayConsume + matchingObj.todayConsume).toFixed(2);
              user.yesConsume = (user.yesConsume + matchingObj.yesConsume).toFixed(2);
              // user.diff = (user.diff + matchingObj.diff).toFixed(2);  // 如果需要对 diff 也进行相加
            }

            // 计算今日与昨日的差值
            user.diff = new Big(user.todayConsume).minus(user.yesConsume).toFixed(2);

            // 计算环比增长率，避免除以零的情况
            if (user.yesConsume !== 0) {
              user.chain = ((user.diff / user.yesConsume) * 100).toFixed(2) + '%';
            } else {
              user.chain = '——'; // 昨日消费为零时，环比显示为“——”
            }
          });

          this.zjCustomerData = this.result;


          const fjToDayAll = new Big(this.zjCustomerData.find(acc => acc.uname === '叶福顺').todayConsume 	)  .round(0, 0) // 四舍五入取整
            .toNumber();  // 转换为数字
          const fjYesDayAll = new Big(this.zjCustomerData.find(acc => acc.uname === '叶福顺').yesConsume 	)  .round(0, 0) // 四舍五入取整
            .toNumber();  // 转换为数字
// 最终计算结果（整数）
          const zjToDayAll =  this.overallData[0].value - fjToDayAll;
          const zjYesDayAll =  this.overallData[1].value - fjYesDayAll;
          this.fujianData[0].value= fjToDayAll
          this.fujianData[1].value= fjYesDayAll
          this.fujianData[2].value= fjToDayAll-fjYesDayAll
          this.fujianData[3].value= new Big( this.fujianData[2].value).div(fjYesDayAll).toFixed(2);

          this.zhejiangData[0].value= zjToDayAll
          this.zhejiangData[1].value= zjYesDayAll
          this.zhejiangData[2].value= zjToDayAll-zjYesDayAll
          this.zhejiangData[3].value= new Big(this.zhejiangData[2].value*100).div(zjYesDayAll).toFixed(2);

          this.$message.success('查询完毕', 2000);
        })
        .catch(error => {
          console.error("请求数据时出错:", error);
        });
    },
    async   getFJData() {
      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };
      // 使用 this.zjcookie 进行请求
      const cookie = this.fjcookie;
      Promise.all([
        fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie),
        fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie)
      ])
        .then(([todayAll, yesAll]) => {
          this.todayAll = todayAll;
          this.yesAll = yesAll;

          this.fjresult = this.fjusers.map(user => {
            const todayConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.todayAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            const yesConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.yesAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            return {
              uname: user.uname,
              todayConsume: Number(todayConsume.toFixed(2)),
              yesConsume: Number(yesConsume.toFixed(2))
            };
          });
          this.fjresult.forEach(user => {
            // 计算今日与昨日的差值
            user.diff =  new Big( user.todayConsume).minus(user.yesConsume).toFixed(2);
            // 计算环比增长率，避免除以零的情况
            if (user.yesConsume !== 0) {
              user.chain = ((user.diff / user.yesConsume) * 100).toFixed(2) + '%';
            } else {
              user.chain = '——'; // 昨日消费为零时，环比显示为“——”
            }
          });
          // this.fjCustomerData = this.fjresult;
          console.log(this.fjresult)

        })
        .catch(error => {
          console.error("请求数据时出错:", error);
        });
    },

  },

};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  background: #f4f7fa;
}

/* 各部分公共样式 */
.section {
  margin-bottom: 30px;
}

.section h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* 三个数据区域卡片的容器及卡片样式 */
.card-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /*padding: 0 10px;*/
}

.card-item {
  flex: 0 0 25%;
  box-sizing: border-box;
  /*padding: 0 10px;*/
}

/* 卡片内部样式 */
.data-card {
  text-align: center;
  background: linear-gradient(135deg, #00c6ff, #0072ff);
  color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.data-title {
  font-size: 16px;
  margin-bottom: 10px;
}

.data-value {
  font-size: 0.9em;
  font-weight: bold;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /*height: 40px; !* 固定高度 *!*/
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 显示 2 行 */
  -webkit-box-orient: vertical;
}

/* 表格样式调整 */
.el-table th,
.el-table td {
  text-align: center;
}

/* 手机端响应式调整：在小屏幕下保持一定的展示效果 */
@media (max-width: 768px) {
  .data-card {
    padding: 15px;
  }
  .section h2 {
    font-size: 18px;
  }
  /* 如果需要在手机端一次显示所有卡片，可考虑减小卡片宽度，或者允许横向滚动 */
  .card-item {
    flex: 0 0 50%;
    margin-bottom: 15px;
  }
  .card-row {
    flex-wrap: wrap;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/weichiAllDataNew.vue